import { render, staticRenderFns } from "./AutoDecimalInput.vue?vue&type=template&id=42485300&"
import script from "./AutoDecimalInput.vue?vue&type=script&lang=ts&"
export * from "./AutoDecimalInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports